/** @typedef {'production'|'staging'|'development'} ExecutionEnvironmentName */

/** @type {Readonly<Record<'PRODUCTION'|'STAGING'|'DEVELOPMENT', ExecutionEnvironmentName>>} */
export const ENVIRONMENT = Object.freeze({
  PRODUCTION: 'production',
  STAGING: 'staging',
  DEVELOPMENT: 'development',
});
